import { TextLink } from './TextLink';

export const HelpBackButton = () => (
  <TextLink className="inline-block no-underline! mb-5" href="/help">
    <span className="material-symbols-outlined align-middle">chevron_left</span> Help home
  </TextLink>
);
